import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { getWhiteLabel } from "./white-label";

const fallbackLng = "en_US";

const getLocaleFromSearchParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("locale");
};

export const getInitialLocale = () => {
  const locale = getLocaleFromSearchParams();
  if (locale) {
    return locale;
  }
  return getWhiteLabel().locale;
};

export const setTranslation = async () => {
  // eslint-disable-next-line import/no-named-as-default-member
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      fallbackLng,
      lng: getInitialLocale(),
      debug: false,
      ns: ["parking:home"], // TODO: set this once the name spaces are defined
      partialBundledLanguages: true,
      react: {
        useSuspense: false,
      },
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
      },
    });
};
